let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dWWc0")).then(() => parcelRequire('4EFQE'));